/* eslint-disable */
;(function(window) {
  let svgSprite =
    '<svg><symbol id="icon-list" viewBox="0 0 1024 1024"><path d="M42.666667 128m42.666666 0l640 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666666l-640 0q-42.666667 0-42.666666-42.666666l0 0q0-42.666667 42.666666-42.666667Z" fill="#999999" ></path><path d="M42.666667 611.541333m42.666666 0l426.666667 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666667l-426.666667 0q-42.666667 0-42.666666-42.666667l0 0q0-42.666667 42.666666-42.666667Z" fill="#999999" ></path><path d="M42.666667 369.792m42.666666 0l853.333334 0q42.666667 0 42.666666 42.666667l0 0q0 42.666667-42.666666 42.666666l-853.333334 0q-42.666667 0-42.666666-42.666666l0 0q0-42.666667 42.666666-42.666667Z" fill="#999999" ></path><path d="M42.666667 853.333333m42.666666 0l810.666667 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666667l-810.666667 0q-42.666667 0-42.666666-42.666667l0 0q0-42.666667 42.666666-42.666667Z" fill="#999999" ></path></symbol><symbol id="icon-statistics" viewBox="0 0 1024 1024"><path d="M468.651166 951.765454c-218.19697 0-395.946007-177.70637-395.946007-395.946007 0-218.154303 177.749037-395.90334 395.946007-395.90334V86.700229c-63.487894 0-124.458459 12.28798-182.314363 36.863938A466.431223 466.431223 0 0 0 137.259718 224.001333 466.431223 466.431223 0 0 0 36.865219 372.993085 464.08456 464.08456 0 0 0 0.00128 555.350114c0 62.975895 12.28798 124.458459 36.863939 182.314363a466.431223 466.431223 0 0 0 100.394499 149.077085 466.431223 466.431223 0 0 0 149.077085 100.394499c57.855904 24.575959 119.338468 36.863939 182.314363 36.863939 63.530561 0 124.458459-12.28798 182.357029-36.863939a466.431223 466.431223 0 0 0 149.034418-100.394499 466.431223 466.431223 0 0 0 100.3945-149.077085c24.575959-57.855904 36.863939-119.338468 36.863938-182.314363h-73.215878c0 219.220968-177.237038 396.415339-395.434007 396.41534z" fill="#999999" ></path><path d="M987.220968 285.355898a464.895225 464.895225 0 0 0-100.181166-148.522419A465.407224 465.407224 0 0 0 738.346716 36.694979 463.444561 463.444561 0 0 0 556.373686 0.001707h-36.266606v503.892493H1023.999573v-36.266606c0-63.317228-12.245313-124.586459-36.778605-182.271696z m-394.538009 145.493091V74.582916c188.586352 17.365304 339.327434 167.93572 356.692739 356.351406h-356.692739z" fill="#999999" ></path></symbol><symbol id="icon-company" viewBox="0 0 1024 1024"><path d="M952.021333 938.666667v-341.333334c0-94.250667-63.104-170.666667-141.056-170.666666h-141.056V170.666667C669.909333 76.373333 606.762667 0 528.853333 0H211.584C133.76 0 70.528 76.373333 70.528 170.624V938.666667H0V1024h1022.549333v-85.333333h-70.528z m-352.512-128.085334v128.128H141.056V170.624c0-47.189333 31.488-85.333333 70.528-85.333333h317.397333c39.04 0 70.528 38.272 70.528 85.333333v640z m282.026667 128.256H669.866667V512h141.056c38.912 0 70.4 38.144 70.4 85.333333v341.504h0.128z" fill="#999999" ></path><path d="M212.437333 467.541333h316.885334v85.205334H212.48v-85.205334z m0 255.786667h316.885334v85.248H212.48v-85.248z m0-511.616h316.885334v85.205333H212.48V211.712z" fill="#999999" ></path></symbol><symbol id="icon-map" viewBox="0 0 1024 1024"><path d="M459.898683 901.041231v-142.966154h59.746462v140.524308l129.851077 33.792a29.420308 29.420308 0 0 1 21.149538 20.48 28.396308 28.396308 0 0 1-7.758769 28.041846 30.444308 30.444308 0 0 1-28.829539 7.483077l-136.664615-35.524923h-5.868308l-136.664615 35.564307a30.050462 30.050462 0 0 1-36.627692-20.519384 28.947692 28.947692 0 0 1 21.110153-35.524923l120.556308-31.31077v-0.039384z" fill="#999999" ></path><path d="M876.587914 605.105231l-25.442462-45.331693-39.936-285.10523 0.039385-0.039385c113.506462 2.126769 137.491692 104.132923 65.378461 330.476308z m-39.857231 99.012923a53.051077 53.051077 0 0 1-47.576615 29.696H200.787298a53.011692 53.011692 0 1 1-43.598769-83.101539l40.448-58.486153 58.171077-447.803077A52.972308 52.972308 0 0 1 308.386068 98.264615h369.152c26.624 0 49.112615 19.731692 52.539077 46.119385l58.683077 449.457231 42.259692 54.508307c12.406154 15.950769 14.651077 37.612308 5.750154 55.768616z m-725.070769-99.800616C39.979914 378.958769 64.989145 277.700923 177.274683 274.786462l0.039385 0.039384-39.345231 282.466462-26.308923 47.02523z m680.093538-393.846153l-11.618461-82.628923A102.754462 102.754462 0 0 0 678.443914 39.384615H309.331298a102.715077 102.715077 0 0 0-101.730461 88.536616L196.139914 210.471385v0.039384c-192.512 3.229538-226.028308 179.672615-107.677539 497.939693a102.793846 102.793846 0 0 0 101.100308 84.243692h608.216615a102.793846 102.793846 0 0 0 100.43077-81.171692c119.138462-319.291077 91.411692-498.176-106.417231-501.051077z" fill="#999999" ></path></symbol></svg>'
  let script = (function() {
    let scripts = document.getElementsByTagName('script')
    return scripts[scripts.length - 1]
  })()
  let shouldInjectCss = script.getAttribute('data-injectcss')
  let ready = function(fn) {
    if (document.addEventListener) {
      if (~['complete', 'loaded', 'interactive'].indexOf(document.readyState)) {
        setTimeout(fn, 0)
      } else {
        var loadFn = function() {
          document.removeEventListener('DOMContentLoaded', loadFn, false)
          fn()
        }
        document.addEventListener('DOMContentLoaded', loadFn, false)
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn)
    }
    function IEContentLoaded(w, fn) {
      let d = w.document,
        done = false,
        init = function() {
          if (!done) {
            done = true
            fn()
          }
        }
      var polling = function() {
        try {
          d.documentElement.doScroll('left')
        } catch (e) {
          setTimeout(polling, 50)
          return
        }
        init()
      }
      polling()
      d.onreadystatechange = function() {
        if (d.readyState == 'complete') {
          d.onreadystatechange = null
          init()
        }
      }
    }
  }
  let before = function(el, target) {
    if (target.parentNode) {
      target.parentNode.insertBefore(el, target)
    }
  }
  let prepend = function(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild)
    } else {
      target.appendChild(el)
    }
  }
  function appendSvg() {
    let div, svg
    div = document.createElement('div')
    div.innerHTML = svgSprite
    svgSprite = null
    svg = div.getElementsByTagName('svg')[0]
    if (svg) {
      svg.setAttribute('aria-hidden', 'true')
      svg.style.position = 'absolute'
      svg.style.width = 0
      svg.style.height = 0
      svg.style.overflow = 'hidden'
      prepend(svg, document.body)
    }
  }
  if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true
    try {
      document.write(
        '<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
      )
    } catch (e) {
      console && console.log(e)
    }
  }
  ready(appendSvg)
})(window)
